/**
 * @module experience/landing/common
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

import { CustomerUsageSummaryResultsLines } from '@support/api/proxies/responses/api-2009.interface';
import { CustomerUsageSummaryBucket } from '@experience/landing/common/interfaces/usage-bucket.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';

export class UsageBucketModel {
  /**
   * to store usage details
   */
  public usageBucket: CustomerUsageSummaryBucket;
  /**
   * to store usage details count
   */
  public usageBucketcount: number;
  /**
   * to store pay go type
   */
  public isPayGoType: boolean;
  /**
   * to store number of usage alerts to be shown before see more
   */
  public seeMoreLimit: number;

  public objectService: ObjectService;

  constructor(
    private lineUsageSummary: CustomerUsageSummaryResultsLines,
    payGoIndicator: boolean,
    objectService: ObjectService
  ) {
    const one: number = 1;
    const two: number = 2;
    this.objectService = objectService;
    this.isPayGoType = payGoIndicator;
    this.usageBucketcount = 0;
    this.seeMoreLimit = this.objectService.get(this.lineUsageSummary, 'dataPass') ? two : one;
    this.usageBucket = {
      bucket: {},
    };
    this.setUsageBucketData(lineUsageSummary);
    this.usageBucketcount = this.getUsageBucketLength();
  }
  /**
   * Sets data for usage details
   * @param {CustomerUsageSummaryResultsLines} lineUsageSummary
   * @returns void
   */
  public setUsageBucketData(lineUsageSummary: CustomerUsageSummaryResultsLines): void {
    if (lineUsageSummary.messages) {
      this.usageBucket.bucket.messages = lineUsageSummary.messages;
    }
    if (lineUsageSummary.minutes) {
      this.usageBucket.bucket.minutes = lineUsageSummary.minutes;
    }
    if (lineUsageSummary.dataPass) {
      this.usageBucket.bucket.dataPass = lineUsageSummary.dataPass;
    }
    if (lineUsageSummary.payGo) {
      this.usageBucket.bucket.payGo = lineUsageSummary.payGo;
    }
    if (lineUsageSummary.data) {
      this.usageBucket.bucket.data = lineUsageSummary.data;
    }
    if (lineUsageSummary.dataTether) {
      this.usageBucket.bucket.dataTether = lineUsageSummary.dataTether;
    }
  }

  public getUsageBucketLength(): number {
    return Object.keys(this.usageBucket.bucket).length;
  }
}
